<template>
  <div class="scanner-page">
    <div class="content-wrapper">
      <!-- 左侧文本内容区域 -->
      <div class="left-content" style="align-items: center;">
        <span class="main-title">{{ $t('series.barcode_scanner') }}<span
            class="sub-title">{{ $t('series.barcode_scanner2') }}</span></span>
        <div v-if="this.$i18n.locale === 'zh'" class="desc">
          <p>扫码筛选裁剪文件，</p>
          <p>扫码选择CAD配置，</p>
          <p>扫码使用预设裁剪参数。</p>
          <p style="color: #808080">快捷不出错，就是了不起。</p>
        </div>

        <div v-else class="desc barcode-desc2">
          <span>File Selection</span>
          <span>CAD Presets</span>
          <span>Parameter Sets</span>
          <span style="margin-top: 30px;color: #808080">Zero keystrokes.</span>
          <span style="color: #808080">Zero errors.</span>
          <span style="color: #808080">Just flawless efficiency at your fingertips.</span>
        </div>
      </div>
      <!-- 右侧图片区域 -->
      <div class="right-content">
        <img src="../../static/series/cutbed/scancode3.png" class="scanner-img">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScannerPage',
  data() {
    return {
      // 可根据实际补充数据，这里主要是布局展示
    };
  },
  mounted() {
    this.$nextTick(() => {
      const masterTimeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: ['.left-content', '.right-content'],
          start: 'top 80%',
          end: 'bottom 20%',
          markers: false,
          // scrub: 1,
          toggleActions: 'play none none none',
          // once: true
        }
      })

      masterTimeline.from('.left-content', {
        opacity: 0,
        y: 200,
        duration: 2,
        ease: 'power2.out'
      }, 0.5)

      masterTimeline.from('.right-content', {
        y: 100,
        x: 150,
        opacity: 0,
        scale: 0.5,
        duration: 2,
        ease: 'power2.out'
      }, 0.5)

      // masterTimeline.to(['.left-content', '.right-content'], {
      //   opacity: 0,
      //   y: -100,
      //   duration: 1,
      //   ease: 'power2.out'
      // }, 2)
    })
  }
};
</script>

<style scoped>
.scanner-page {
  width: 100%;
  background-color: #fff;
  padding: 1.875em 1.25em;
  box-sizing: border-box;
  margin-top: 300px;
  position: relative;
}

.content-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center; /* 整体内容居中 */
  align-items: center;
  gap: 2em; /* 左右内容间距 */
}

.left-content {
  position: absolute;
  align-items: center;
  translate: none;
  rotate: none;
  scale: none;
  transform: translate(0px, 0px);
  opacity: 1;
  left: 18%;
}

.main-title {
  font-size: 3em;
  color: #3498db;
  margin-bottom: 0.625em;
  text-align: left; /* 确保标题左对齐 */
}

.sub-title {
  font-size: 0.5em;
  color: #999;
  font-weight: normal;
}

.desc {
  width: 425px;
  margin-top: 1.25em;
}

.desc p {
  font-size: 1.5em;
  color: #333;
  line-height: 1.6;
  margin: 0 0 0 0;
  text-align: left; /* 确保段落左对齐 */
}

.right-content {
  flex: 1;
  min-width: 17.5em;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  margin-left: 700px;
}

.scanner-img {
  max-width: 100%;
  max-height: 50em;
  height: auto;
}

.barcode-desc2 {
  display: flex;
  flex-direction: column;
  text-align: left;
  font-size: var(--font-size-lg);
  width: 100%;
}

/* 响应式适配 */
@media (max-width: 48em) {
  /* 768px = 48em (1em=16px) */
  .content-wrapper {
    flex-direction: column;
  }

  .left-content {
    max-width: 100%;
    margin-bottom: 1.25em;
  }
}
</style>
